/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  ExportMeetingsByUserRequest,
  GetMeetingsByUserRequest,
  HttpQueryResponseGetMeetingsResponse,
  MapString,
  Meeting,
  PublicMeeting,
  UsedUtmParameters,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "meetings";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns a meeting by an id.
   *
   * @tags public
   * @name GetAMeeting
   * @request GET:/v1/tenant/{tenantId}/meeting/{meetingId}
   * @secure
   */
  getAMeeting = (tenantId: string, meetingId: string, params: RequestParams = {}) =>
    this.request<
      Meeting,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/meeting/${meetingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAMeeting */
  getAMeetingPathGetter = (tenantId: string, meetingId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/meeting/${meetingId}`);

  /**
   * @description Returns a list of meetings.
   *
   * @tags public
   * @name ListMeetingsByAFilter
   * @request POST:/v1/tenant/{tenantId}/meetings/by-filter
   * @secure
   */
  listMeetingsByAFilter = (tenantId: string, data: GetMeetingsByUserRequest, params: RequestParams = {}) =>
    this.request<
      HttpQueryResponseGetMeetingsResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/meetings/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listMeetingsByAFilter */
  listMeetingsByAFilterPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/meetings/by-filter`);

  /**
   * @description Export meetings
   *
   * @tags public
   * @name ExportMeetings
   * @request POST:/v1/tenant/{tenantId}/meetings/export/csv
   * @secure
   */
  exportMeetings = (
    tenantId: string,
    data: ExportMeetingsByUserRequest,
    query?: {
      timezone?: string;
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/meetings/export/csv`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for exportMeetings */
  exportMeetingsPathGetter = (
    tenantId: string,
    query?: {
      timezone?: string;
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/meetings/export/csv`, query);

  /**
   * @description Returns all used utm parameters.
   *
   * @tags public
   * @name UsedUtmParameters
   * @request GET:/v1/tenant/{tenantId}/meetings/used-utm-parameters
   * @secure
   */
  usedUtmParameters = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      workspaceId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UsedUtmParameters,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/meetings/used-utm-parameters`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for usedUtmParameters */
  usedUtmParametersPathGetter = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      workspaceId?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/meetings/used-utm-parameters`, query);

  /**
   * @description Returns public fields of a meeting by an id.
   *
   * @tags public
   * @name GetAPublicMeeting
   * @request GET:/v1/public/tenant/{tenantId}/meeting/{meetingId}
   */
  getAPublicMeeting = (tenantId: string, meetingId: string, params: RequestParams = {}) =>
    this.request<
      PublicMeeting,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting/${meetingId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getAPublicMeeting */
  getAPublicMeetingPathGetter = (tenantId: string, meetingId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/meeting/${meetingId}`);
}
